import { ReactNode } from 'react'

import clsx from 'clsx'

import { useNotificationsCount } from '@tribeplatform/react-sdk/hooks'
import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown'
import { IndicatorBadge } from '@tribeplatform/react-ui-kit/IndicatorBadge'

import { NotificationDropdownList } from '../../Notification/NotificationDropdownList'
import { NavbarControlItem } from '../constants'

export type NavbarControlNotificationProps = {
  item: NavbarControlItem
  presentation: ReactNode
}

export const NavbarControlNotification = ({
  item,
  presentation,
}: NavbarControlNotificationProps) => {
  const { data: notificationCount } = useNotificationsCount()

  return (
    <Dropdown placement="bottom-end">
      <Dropdown.ButtonMinimal
        className="w-10 h-10 items-center justify-center"
        aria-label={item.label}
      >
        <IndicatorBadge
          className={clsx('translate-y-0', {
            // Placement of the badge when the count is "99+"
            'right-1': notificationCount > 99,
          })}
          count={notificationCount}
        >
          {presentation}
        </IndicatorBadge>
      </Dropdown.ButtonMinimal>
      <Dropdown.Items className="w-96">
        {({ close }) => <NotificationDropdownList closeDropdown={close} />}
      </Dropdown.Items>
    </Dropdown>
  )
}
